/**
 * CHG-052 REQ-V52-007: 이슈 타입 관리 API 서비스
 */
import api from '../lib/axios';
import type { ApiResponse } from '@maios/shared';

export interface IssueTypeDefinition {
  issueTypeId: string;
  name: string;
  description: string | null;
  icon: string;
  color: string;
  customIconPath: string | null;  // CHG-053
  isSystem: boolean;
  createdById: string | null;
  createdAt: string;
  updatedAt: string;
  usageCount: number;
  schemeCount: number;
}

export interface CreateIssueTypeData {
  name: string;
  description?: string;
  icon: string;
  color: string;
}

export interface UpdateIssueTypeData {
  name?: string;
  description?: string | null;
  icon?: string;
  color?: string;
}

export async function fetchIssueTypes(): Promise<IssueTypeDefinition[]> {
  const res = await api.get<ApiResponse<{ issueTypes: IssueTypeDefinition[] }>>('/admin/issue-types');
  return res.data.data!.issueTypes;
}

export async function createIssueType(data: CreateIssueTypeData) {
  const res = await api.post<ApiResponse<IssueTypeDefinition>>('/admin/issue-types', data);
  return res.data.data!;
}

export async function updateIssueType(issueTypeId: string, data: UpdateIssueTypeData) {
  const res = await api.put<ApiResponse<IssueTypeDefinition>>(`/admin/issue-types/${issueTypeId}`, data);
  return res.data.data!;
}

export async function deleteIssueType(issueTypeId: string) {
  await api.delete(`/admin/issue-types/${issueTypeId}`);
}

// CHG-053: 커스텀 아이콘 업로드/삭제
export async function uploadIssueTypeIcon(issueTypeId: string, file: File): Promise<{ customIconPath: string }> {
  const formData = new FormData();
  formData.append('icon', file);
  const res = await api.post<ApiResponse<{ customIconPath: string }>>(`/admin/issue-types/${issueTypeId}/icon`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data.data!;
}

export async function deleteIssueTypeIcon(issueTypeId: string): Promise<{ icon: string }> {
  const res = await api.delete<ApiResponse<{ icon: string }>>(`/admin/issue-types/${issueTypeId}/icon`);
  return res.data.data!;
}
